module.exports = __webpack_public_path__ + "img/zxjs1.9b2f36d4.png";